import slugify from 'slugify';

// Slug generation and validation utility functions
export function generateSlug(name) {
  if (!name) return '';
  
  return slugify(name, {
    lower: true, // convert to lower case
    strict: true, // strip special characters except replacement
    trim: true, // trim leading and trailing replacement chars
    locale: 'vi', // language code of the locale to use
    remove: /[*+~.()'"!:@]/g // regex to remove characters
  });
}

// validate slug
export function isValidSlug(slug) {
  const slugRegex = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
  return slugRegex.test(slug);
}

// Check if slug has leading/trailing spaces
export function hasLeadingOrTrailingSpaces(text) {
  return text !== text.trim();
}

// Validate slug length
export function isValidSlugLength(slug) {
  return slug && slug.length >= 3;
}